import React, { useState, useRef, useEffect } from "react";
import { useFormik } from "formik";
import { useSnackbar } from "notistack";
import { useAuth } from "./AuthContext/AuthContext";
import OTPModal from '../components/SolicitudCredito/SolicitudCreditoForm/OTPModal';
import { APIURL } from "../configApi/apiConfig";
import axios from "../configApi/axiosConfig";
import { useNavigate } from "react-router-dom";
import { Loader } from "../components/Utils/Loader";
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import { MotivoContinuidad } from "../components/ListadoSolicitud";
import { SolicitudExitosa } from "./MensajeSolicitudExitosa/SolicitudExitosa";
import { ImLeaf } from "react-icons/im";
import payjoy from "../img/payjoy.png";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BadgeIcon from "@mui/icons-material/Badge";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PersonIcon from "@mui/icons-material/Person";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import StoreIcon from '@mui/icons-material/Store';
import CakeIcon from '@mui/icons-material/Cake';
import WorkIcon from '@mui/icons-material/Work';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import HomeIcon from '@mui/icons-material/Home';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CircularProgress from '@mui/material/CircularProgress';

const getFieldIcon = (fieldName) => {
  switch (fieldName) {
    case "Bodega":
      return <StoreIcon className="mr-2 text-primaryBlue" fontSize="small" />;
    case "idCompraEncuesta":
      return <AssignmentIcon className="mr-2 text-primaryBlue" fontSize="small" />;
    case "Cedula":
      return <BadgeIcon className="mr-2 text-primaryBlue" fontSize="small" />;
    case "ApellidoPaterno":
    case "ApellidoMaterno":
    case "PrimerNombre":
    case "SegundoNombre":
      return <PersonIcon className="mr-2 text-primaryBlue" fontSize="small" />;
    case "FechaNacimeinto":
    case "Edad":
      return <CakeIcon className="mr-2 text-primaryBlue" fontSize="small" />;
    case "idSituacionLaboral":
      return <WorkIcon className="mr-2 text-primaryBlue" fontSize="small" />;
    case "Celular":
      return <PhoneIcon className="mr-2 text-primaryBlue" fontSize="small" />;
    case "Email":
      return <EmailIcon className="mr-2 text-primaryBlue" fontSize="small" />;
    case "idActEconomina":
      return <BusinessCenterIcon className="mr-2 text-primaryBlue" fontSize="small" />;
    case "idCre_Tiempo":
      return <WorkIcon className="mr-2 text-primaryBlue" fontSize="small" />;
    case "idCre_TiempoVivienda":
      return <HomeIcon className="mr-2 text-primaryBlue" fontSize="small" />;
    case "idProductos":
      return <ShoppingCartIcon className="mr-2 text-primaryBlue" fontSize="small" />;
    default:
      return null;
  }
};

const CAMPOS_PERSONALES = [
  "PrimerNombre",
  "SegundoNombre",
  "ApellidoPaterno",
  "ApellidoMaterno",
  "FechaNacimeinto",
  "Edad",
  "idSituacionLaboral",
  "Celular",
  "Email",
  "idActEconomina",
  "idCre_Tiempo",
  "idCre_TiempoVivienda",
];

const resetCamposPersonalesFormik = (formik) => {
  CAMPOS_PERSONALES.forEach((campo) => formik.setFieldValue(campo, ""));
  formik.setFieldValue("bTerminosYCondiciones", false);
  formik.setFieldValue("bPoliticas", false);
};

const FormField = ({
  label,
  name,
  type = "text",
  formik,
  component: Component,
  options = [],
  onchange,
  hidden,
  previewUrl,
  setPreviewUrl,
  datosPersonalesVisible,
  setDatosPersonalesVisible,
  setClienteRecurrenteA,
  ...props
}) => {

  const { enqueueSnackbar } = useSnackbar();

  const [isBlacklisted, setIsBlacklisted] = useState(false);
  const [mensajeExitoso, setMensajeExitoso] = useState(false);
  const [soliExistente, setSoliExistente] = useState(null)

  if (hidden) {
    return null;
  }

  const handleFileChange = (event) => {

    try {
      const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
      const file = event.target.files ? event.target.files[0] : null;

      if (!file) return;

      if (!SUPPORTED_FORMATS.includes(file.type)) {
        throw new Error("El archivo debe ser una imagen (JPG, PNG)");
      }

      formik.setFieldValue(name, file);
      setPreviewUrl(URL.createObjectURL(file));
    } catch (error) {
      formik.setFieldError(name, error.message);
      enqueueSnackbar(error.message, { variant: "error" });
    }
  };

  const comprobTelf = async (telefono) => {
    try {
      const url = APIURL.validarTelefono(telefono);
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Error al validar el teléfono:", error);
      return false;
    }
  };

  const comprobcedula = async (cedula) => {
    try {
      const url = APIURL.validarCedula(cedula);
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Error al validar el cedula:", error);
      return false;
    }
  };

  const comprobEmail = async (email) => {
    try {
      const url = APIURL.validarEmail(email);
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error("Error al validar el email:", error);
      return false;
    }
  };

  const handleInputChange = async (e) => {
    let { name, value } = e.target;


    if (name === "Cedula" || name === "Celular") {
      value = value.replace(/\D/g, "");
      value = value.slice(0, 10);
    }

    if (name === "ApellidoMaterno" || name === "ApellidoPaterno" || name === "PrimerNombre" || name === "SegundoNombre") {
      value = value.replace(/[^A-Za-zÁÉÍÓÚáéíóúÑñ\s]/g, "").toUpperCase();
    }

    if (name === "Celular" && value.length === 10) {
      const existe = await comprobTelf(value);


      if (existe === 1) {
        enqueueSnackbar(`El número ${value} se encuentra en la lista negra`, {
          variant: 'warning'
        });
        setIsBlacklisted(true);
        return;
      } else {
        setIsBlacklisted(false);
      }
    }

    if (name === "Cedula" && value.length === 10) {
      const existe = await comprobcedula(value);

      if (existe === 1) {
        enqueueSnackbar(`La cédula ${value} se encuentra en la lista negra`, {
          variant: 'warning'
        });
        setIsBlacklisted(true);
        return;
      } else {
        // Aquí validamos además la combinación cédula + bodega
        const bodega = formik.values.Bodega; // Asegúrate que este campo exista y se llame así
        if (bodega) {
          const existeCombo = await verificarCedulaBodega(value);
          if (existeCombo) {
            /* enqueueSnackbar(`Ya existe una solicitud con la cédula ${value}`, {
               variant: 'warning'
             });*/
            setMensajeExitoso(true)
            setIsBlacklisted(true);
            return;
          }
        }

        setIsBlacklisted(false);
      }
    }

    // Agregar validación para email
    if (name === "Email" && value.includes('@')) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(value)) {
        const existe = await comprobEmail(value);

        if (existe === 1) {
          enqueueSnackbar(`El email ${value} se encuentra en la lista negra`, {
            variant: 'warning'
          });
          setIsBlacklisted(true);
          return;
        } else {
          setIsBlacklisted(false);
        }
      }
    }

    formik.setFieldValue(name, value);
  };
  const verificarCedulaBodega = async (cedula) => {
    try {
      const response = await axios.get(APIURL.verificarRegistroSolicitud(cedula), {
      });
      setSoliExistente(response.data.solicitud)

      return response.data.existe === true;
    } catch (error) {
      console.error("Error al verificar existencia de solicitud:", error);
      return false; // por defecto, asumir que no existe para no bloquear
    }
  };




  if (type === "button") {
    return (
      <div className="w-full place-items-center mt-8">
        <button
          type="button"
          className="rounded-full hover:shadow-md transition duration-300 ease-in-out group bg-gray-400 text-white border border-white hover:bg-white hover:text-gray-400 hover:border-gray-400 text-xs px-6 py-2.5"
          onClick={props.onClick}
        >
          {label}
        </button>
      </div>
    );
  }



  // Si es un campo de tipo archivo, renderizamos una estructura diferente
  if (type === "file") {
    return (
      <div className="flex flex-col h-full">
        <label htmlFor={name} className="text-sm mb-1">
          {label}
        </label>
        <div className="flex flex-col h-full">
          <label
            htmlFor={name}
            className="rounded-full hover:shadow-md transition duration-300 ease-in-out group bg-primaryBlue text-white border border-white hover:bg-white hover:text-primaryBlue hover:border-primaryBlue text-xs px-6 py-2.5 cursor-pointer inline-block text-center w-full"
          >
            Seleccionar foto
            <input
              id={name}
              name={name}
              type="file"
              onChange={handleFileChange}
              onBlur={formik.handleBlur}
              className="hidden"
              accept="image/*"
              {...props}
            />
          </label>
          {previewUrl && (
            <div className="mt-4 flex justify-center">
              <div className="w-40 h-45">
                <img
                  src={previewUrl}
                  alt="Preview"
                  className="w-full h-full object-cover rounded-md border"
                />
              </div>
            </div>
          )}
        </div>
        {formik.errors[name] && formik.touched[name] && (
          <p className="text-red-500 text-xs mt-1">{formik.errors[name]}</p>
        )}
      </div>
    );
  }

  const hasError = formik.errors[name] && formik.touched[name];
  const isDisabled = props.disabled;

  return (
    <div className="flex flex-col w-full">
      <label htmlFor={name} className="flex items-center text-sm font-semibold text-slate-700 mb-2">
        {getFieldIcon(name)}
        {label}
      </label>

      {Component ? (
        <Component
          {...props}
          onLocationSelect={(location) => formik.setFieldValue(name, location)}
        />
      ) : type === "select" ? (
        <select
          id={name}
          name={name}
          onChange={(e) => {
            const val = e.target.value;
            formik.handleChange(e);
            if (onchange) onchange(val);

            // Si se cambia el producto o la bodega y ya se habían consultado los datos, resetear para obligar a validar de nuevo
            if ((name === "idProductos" || name === "Bodega") && datosPersonalesVisible && setDatosPersonalesVisible) {
              setDatosPersonalesVisible(false);
              resetCamposPersonalesFormik(formik);
              if (setClienteRecurrenteA) setClienteRecurrenteA(false);
            }
          }}
          onBlur={formik.handleBlur}
          value={formik.values[name] ?? ""}
          className={`w-full px-4 py-2.5 rounded-lg border ${hasError
            ? "border-red-400 bg-red-50 focus:border-red-500 focus:ring-red-200"
            : isDisabled
              ? "border-slate-300 bg-gray-100 text-gray-500 cursor-not-allowed"
              : "border-slate-300 bg-white focus:border-primaryBlue focus:ring-blue-200"
            } focus:outline-none focus:ring-2 transition-all duration-200 text-sm`}
          {...props}
        >
          <option value="">
            Selecciona una opción
          </option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ) : type === "checkbox" ? (
        <input
          id={name}
          name={name}
          type="checkbox"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          checked={formik.values[name]}
          className="mr-2 rounded text-primaryBlue focus:ring-primaryBlue"
          {...props}
        />
      ) : type === "switch" ? (
        <div className="flex items-center gap-2">
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              id={name}
              name={name}
              type="checkbox"
              className="sr-only peer"
              onChange={(e) => formik.setFieldValue(name, e.target.checked)}
              onBlur={formik.handleBlur}
              checked={formik.values[name]}
              {...props}
            />
            <div className="w-11 h-6 bg-gray-300 peer-focus:ring-2 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-1 after:left-1 after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primaryBlue"></div>
          </label>
        </div>
      ) : (
        <input
          id={name}
          name={name}
          type={type}
          onChange={handleInputChange}
          onBlur={formik.handleBlur}
          value={formik.values[name] ?? ""}
          className={`w-full px-4 py-2.5 rounded-lg border ${hasError
            ? "border-red-400 bg-red-50 focus:border-red-500 focus:ring-red-200"
            : isDisabled
              ? "border-slate-300 bg-gray-100 text-gray-500 cursor-not-allowed"
              : "border-slate-300 bg-white focus:border-primaryBlue focus:ring-blue-200"
            } focus:outline-none focus:ring-2 transition-all duration-200 text-sm`}
          {...props}
        />
      )}

      {hasError && (
        <p className="mt-1 text-xs text-red-600 font-medium">{formik.errors[name]}</p>
      )}

      <SolicitudExitosa
        isOpen={mensajeExitoso}
        onClose={() => setMensajeExitoso(false)}
        titulo={`¡TIENES UNA SOLICITUD DE CRÉDITO ACTIVA!`}
        subtitulo={`Por favor completa la solicitud de crédito que el cliente ya tiene activa.`}
        li1={`Cliente ${`${soliExistente?.PrimerNombre} ${soliExistente?.ApellidoPaterno}`} con cedula ${soliExistente?.Cedula}`}
        li2={`Números de solicitud: ${soliExistente?.NumeroSolicitud} `}
        color={'bg-red-100'}
        ruta={`/solicitud`}
      />
    </div>
  );
};

const ReusableForm = ({
  initialValues,
  formConfig,
  validationSchema,
  onSubmit,
  includeTermsAndConditions = false,
  includeButtons = false,
  submitButtonText = "Enviar",
  cancelButtonText = "Cancelar",
  returnButtonText = "Regresar",
  loading = false,
  onCancel,
  columns = 1,
  formStatus,
  onExternalUpdate,
  soliGrande,
  creSoliWeb,
  bodegaSeleccionada,
  datosPersonalesVisible = false,
  setDatosPersonalesVisible,
  clienteRecurrenteA = false,
  setClienteRecurrenteA,
  onValidarCedula,
  onCedulaChange,
  loadingCedula = false,
}) => {

  const getFieldConfig = (name) => formConfig?.find((f) => f.name === name);

  const navigate = useNavigate();
  const { userData } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isCanceling, setIsCanceling] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isOtpModalOpen, setIsOtpModalOpen] = useState(false); // Estado para controlar la apertura del modal de OTP
  const [isOtpVerified, setIsOtpVerified] = useState(false); // Estado para verificar si el OTP es válido
  // Vigencia real del código, según Almacenes.OTP_TiempoMinutos de la bodega (la decide el backend)
  const [otpExpiraEnMinutos, setOtpExpiraEnMinutos] = useState(5);
  // Resuelve la Promise que requestOtp() devuelve al onSubmit, una vez que
  // verificarOtpCode() confirma el código (mismo patrón que Cabecera.js).
  const otpResolverRef = useRef(null);
  const [dataMotivos, setDataMotivos] = useState({
    totalCount: 0,
    data: []
  });
  const [dataMotivosBodega, setDataMotivosBodega] = useState({
    totalCount: 0,
    data: []
  });
  const [dataInforme, setDataInforme] = useState(null);
  // Guarda el producto enviado porque formik.resetForm() limpia formik.values antes de mostrar el modal de resultado
  const [productoEnviado, setProductoEnviado] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [isOpenMotivo, setIsOpenMotivo] = useState(false);
  // captura a valores de inicialValues
  // Inicializar valores por defecto para campos select
  const selectDefaults = Object.fromEntries(
    formConfig
      .filter((field) => field.type === "select")
      .map((field) => [field.name, ""])
  );
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [mensajeExitoso, setMensajeExitoso] = useState(false)

  useEffect(() => {
    const idVendedor = initialValues?.idVendedor || userData?.idPersonal || userData?.idUsuario;
    if (idVendedor) {
      verificarMotivosPendientes(idVendedor);
    }
  }, [initialValues?.idVendedor, userData?.idPersonal, userData?.idUsuario, isOpenMotivo]);

  useEffect(() => {
    if (bodegaSeleccionada > 0) {
      const fetchMotivos = async () => {
        await verificaMotivoContinuidadBodega(bodegaSeleccionada);
      };
      fetchMotivos();
    }
  }, [bodegaSeleccionada]);

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      // Bloqueo de seguridad: Si es iPhone o Motos, debe estar calificado como recurrente bueno
      if ((Number(values.idProductos) === 8 || Number(values.idProductos) === 10) && !clienteRecurrenteA) {
        enqueueSnackbar("Para solicitar crédito en este producto debes validar la cédula del cliente.", {
          variant: "error",
          autoHideDuration: 6000,
        });
        return;
      }

      setIsButtonDisabled(true)

      // Quién exige OTP lo decide el backend según Almacenes.OTP para la bodega
      // seleccionada (ya no un id quemado aquí): siempre se llama y se confía en
      // la respuesta, igual que enviarYVerificarOtp() en Cabecera.js.
      const otpVerificado = await requestOtp();
      if (!otpVerificado) {
        setIsButtonDisabled(false);
        return;
      }

      handleOtpVerification(true);
    },
  });

  useEffect(() => {
    if (onExternalUpdate) {
      onExternalUpdate(formik);
    }
  }, [onExternalUpdate]);

  // Genera el OTP y abre el modal; devuelve una Promise que se resuelve
  // cuando verificarOtpCode() confirma el código (o el usuario cierra el
  // modal sin verificar). Mismo patrón que enviarYVerificarOtp() en
  // Cabecera.js.
  const requestOtp = async () => {
    const otpPromise = new Promise((resolve) => { otpResolverRef.current = resolve; });
    try {
      const url = APIURL.generateOTP();
      const response = await axios.post(url, {
        phoneNumber: formik.values.Celular,
        email: formik.values.Email,
        nombreCompleto: `${formik.values.PrimerNombre || ''} ${formik.values.SegundoNombre || ''} ${formik.values.ApellidoPaterno || ''} ${formik.values.ApellidoMaterno || ''}`.trim(),
        cedula: formik.values.Cedula,
        bodega: formik.values.Bodega
      });

      if (!response.data.success) {
        enqueueSnackbar(response.data.message || "No se pudo generar el OTP.", { variant: "error" });
        otpResolverRef.current?.(false);
        otpResolverRef.current = null;
        return false;
      }

      if (response.data.requiereOtp === false) {
        // Esta bodega no tiene Almacenes.OTP=1: no se pide código, se continúa directo.
        otpResolverRef.current = null;
        return true;
      }

      setOtpExpiraEnMinutos(response.data.expiresInMinutes || 5);
      setIsOtpModalOpen(true);
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Hubo un error al generar el OTP.', { variant: "error" });
      otpResolverRef.current?.(false);
      otpResolverRef.current = null;
      return false;
    }
    return otpPromise;
  };

  // verifyFn del OTPModal: verifica el código contra el backend y resuelve
  // la Promise de requestOtp() para que el submit continúe.
  const verificarOtpCode = async (otpCode) => {
    try {
      const response = await axios.post(APIURL.verifyOTP(), {
        phoneNumber: formik.values.Celular,
        otpCode,
        cedula: formik.values.Cedula,
        bodega: formik.values.Bodega,
      });
      if (response.data.success) {
        setIsOtpModalOpen(false);
        otpResolverRef.current?.(true);
        otpResolverRef.current = null;
      }
      return { success: response.data.success };
    } catch (error) {
      if (error.response?.status === 401) return { success: false };
      enqueueSnackbar("Error al verificar el OTP.", { variant: "error" });
      return { success: false };
    }
  };

  // onClose del OTPModal: si el usuario cierra sin verificar, el submit no continúa
  const handleOtpModalClose = () => {
    setIsOtpModalOpen(false);
    setIsButtonDisabled(false);
    otpResolverRef.current?.(false);
    otpResolverRef.current = null;
  };


  // Sistema unificado para mostrar el primer error en el submit
  const showFirstError = () => {
    const errorKeys = Object.keys(formik.errors);

    if (errorKeys.length > 0) {
      const firstErrorKey = errorKeys[0];
      const errorMessage = formik.errors[firstErrorKey];

      enqueueSnackbar(errorMessage, {
        variant: "error",
        preventDuplicate: true
      });

      // Marcar como tocado para que se muestre visualmente
      formik.setFieldTouched(firstErrorKey, true);
    }
  };

  //   Reset del formulario cuando status es success
  //   useEffect(() => {
  //     formik.resetForm();
  //   }, [isOtpVerified]);

  const handleCancel = () => {
    setIsCanceling(true);
    formik.resetForm();
    setPreviewUrl(null);
    if (setDatosPersonalesVisible) setDatosPersonalesVisible(false);
    if (onCancel) onCancel();
    setTimeout(() => setIsCanceling(false), 1000);
  };

  //   const handleOtpVerification = (isVerified) => {
  //     setIsOtpVerified(isVerified);
  //     setIsOtpModalOpen(false); // Cerrar el modal después de la verificación del OTP
  //   };

  const handleOtpVerification = async (isVerified, otpCode = null) => {
    if (isVerified) {
      //   let otpCodeString = String(otpCode);
      //   // Se asigna el OTP al objeto de Formik
      //   formik.values.otp_code = otpCodeString;

      if (otpCode) {
        formik.values.otp_code = String(otpCode);
      }

      setIsSubmitting(true);
      try {
        await onSubmit(formik.values);
        // Espera 2 segundos para que el loader se muestre
        await new Promise((resolve) => setTimeout(resolve, 2000));
        setProductoEnviado(formik.values.idProductos);
        formik.resetForm();
        setPreviewUrl(null);
        setMensajeExitoso(true)
        // setTimeout(() => {
        // 	navigate("/ListadoSolicitud", { replace: true });
        // }, 20000);

      } catch (error) {
        enqueueSnackbar("Error al enviar el formulario", { variant: "error" });
        console.error("Error en envío:", error);
        setIsButtonDisabled(false)
      } finally {
        setIsSubmitting(false);
      }
    } else {
      setIsButtonDisabled(false)
    }
    setIsOtpModalOpen(false);
    setIsOtpVerified(isVerified);
  };

  const verificarMotivosPendientes = async (vendedor) => {
    try {
      const response = await axios.get(APIURL.get_Count_get_motivosContinuidad(vendedor));
      const { totalCount, data } = response.data;
      if (totalCount > 0) {
        setDataMotivos(response.data);
      } else {

        setDataMotivos({
          totalCount: 0,
          data: []
        });
      }
    } catch (error) {
      console.error("Error al verificar motivos pendientes:", error);
      enqueueSnackbar("Error al verificar motivos pendientes", { variant: "error" });
      setDataMotivos({
        totalCount: 0,
        data: []
      });
    }
  };

  const verificaMotivoContinuidadBodega = async (bodega) => {
    try {

      const response = await axios.get(APIURL.get_Count_get_motivosContinuidad_Bodega(bodega));
      const { totalCount, data } = response.data;
      if (totalCount > 0) {
        setDataMotivosBodega(response.data);
      } else {
        setDataMotivosBodega({
          totalCount: 0,
          data: []
        });
      }
    } catch (error) {
      console.error("Error al verificar motivos pendientes por bodega:", error);
      enqueueSnackbar("Error al verificar motivos pendientes por bodega", { variant: "error" });
      setDataMotivosBodega({
        totalCount: 0,
        data: []
      });
    }
  };


  // Separar el campo de archivo y otros campos
  const fileField = formConfig.find((field) => field.type === "file");
  const otherFields = formConfig.filter((field) => field.type !== "file");

  // PayJoy solo cubre MOVILIDAD (3) e IPHONE (8); el resto de productos requiere ofrecer otras formas de pago.
  const esProductoPayjoy = [3, 8].includes(Number(productoEnviado));

  // Validación y control para el flujo progresivo de Cédula y Producto
  const esFormularioListoParaValidar = Boolean(
    formik.values.Bodega &&
    formik.values.idCompraEncuesta &&
    formik.values.idProductos &&
    formik.values.Cedula?.length === 10
  );

  const handleEjecutarValidacionCedula = () => {
    if (!formik.values.Bodega) {
      enqueueSnackbar("Por favor selecciona una bodega", { variant: "warning" });
      return;
    }
    if (!formik.values.idCompraEncuesta) {
      enqueueSnackbar("Por favor selecciona un tipo de consulta", { variant: "warning" });
      return;
    }
    if (!formik.values.idProductos) {
      enqueueSnackbar("Por favor selecciona un producto", { variant: "warning" });
      return;
    }
    if (formik.values.Cedula?.length !== 10) {
      enqueueSnackbar("La cédula debe tener 10 dígitos", { variant: "warning" });
      return;
    }
    if (onValidarCedula) {
      onValidarCedula(formik.values.Cedula, formik.values);
    }
  };

  const handleCedulaInputChange = (e) => {
    const val = e.target.value.replace(/\D/g, '').slice(0, 10);
    const huboCambio = val !== (formik.values.Cedula ?? "");
    formik.setFieldValue("Cedula", val);

    // Cualquier edición de la cédula (borrar dígitos o pegar una distinta,
    // aunque siga teniendo 10 dígitos) invalida los datos ya consultados.
    if (huboCambio && (datosPersonalesVisible || clienteRecurrenteA)) {
      if (onCedulaChange) {
        // El padre (CreditoForm) resetea también su propio estado externo
        // (dataRecibir, solicitudActiva, soliExistente, etc.), no solo formik.
        onCedulaChange(val);
      } else if (setDatosPersonalesVisible) {
        setDatosPersonalesVisible(false);
        resetCamposPersonalesFormik(formik);
        if (setClienteRecurrenteA) setClienteRecurrenteA(false);
      }
    }
  };
  return (
    <div className="relative">
      {isSubmitting && (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-white bg-opacity-75">
          <Loader />
        </div>
      )}

      {parseInt(dataMotivos?.totalCount || 0) > 0 && (
        <>
          <label className="text-lg font-semibold text-primaryBlue mb-4">
            <span className="text-red-500 ml-2">
              Pendientes de Ingresar el motivo de continuidad {dataMotivos.totalCount} motivo(s) pendiente(s)
            </span>
          </label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            {dataMotivos.data && dataMotivos.data.map((motivo, idx) => (

              <div key={idx} className="bg-white shadow-md rounded-lg p-4 mb-4 border border-gray-200">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <span className="inline-block bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-sm font-medium">
                      {motivo.NumeroSolicitud}
                    </span>
                    <span className="text-gray-500 text-sm">({new Date(motivo.Fecha).toLocaleDateString()})</span>
                  </div>
                  <div className="text-xs text-gray-400">🕒 {new Date(motivo.Fecha).toLocaleTimeString()}</div>
                </div>

                <div className="flex items-center gap-3">

                  <div className="text-sm text-gray-800">
                    <div><strong>Cédula:</strong> {motivo.Cedula}</div>
                  </div>
                  <button
                    onClick={() => {
                      setIsOpenMotivo(true);
                      setDataInforme({
                        id: Array.isArray(motivo.idCre_SolicitudWeb) ? motivo.idCre_SolicitudWeb[0] : motivo.idCre_SolicitudWeb,
                        PrimerNombre: motivo.PrimerNombre,
                        SegundoNombre: motivo.SegundoNombre,
                        ApellidoPaterno: motivo.ApellidoPaterno,
                        ApellidoMaterno: motivo.ApellidoMaterno,
                        cedula: motivo.Cedula,
                        NumeroSolicitud: motivo.NumeroSolicitud,
                        Fecha: motivo.Fecha,
                      });
                    }}
                    className="bg-pink-100 text-pink-800 hover:bg-pink-200 hover:text-pink-900 transition-all duration-200 rounded-full p-2"
                  >
                    <NoteAltIcon className="text-pink-800" />
                  </button>
                </div>
              </div>

            ))}

          </div>
        </>
      )}
      {(dataMotivosBodega?.totalCount ?? 0) > 0 && (
        <div className="bg-red-50 border border-red-200 rounded-xl p-4 shadow-sm">

          {/* HEADER */}
          <div className="flex items-start gap-3 mb-4">
            <WarningAmberIcon className="text-red-500 mt-1" />
            <div>
              <h2 className="text-red-600 font-semibold text-lg">
                Solicitudes pendientes en almacén
              </h2>
              <p className="text-sm text-gray-700">
                Tiene <strong>{dataMotivosBodega.totalCount}</strong> solicitud(es) pendientes.
                Si no se gestionan, el sistema puede restringir nuevas consultas.
              </p>
              <p className="text-sm text-gray-600 mt-1">
                Comuníquese con el vendedor o jefe de almacén para su regularización.
              </p>
            </div>
          </div>

          {/* LISTADO */}


          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {dataMotivosBodega.data?.map((motivo, idx) => (
              <div
                key={idx}
                className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-lg transition-all duration-200"
              >

                {/* HEADER */}
                <div className="flex justify-between items-start mb-3">
                  <div className="flex items-center gap-2 text-primaryBlue font-semibold text-base">
                    <AssignmentIcon fontSize="small" />
                    <span>{motivo.NumeroSolicitud}</span>
                  </div>

                  <div className="flex flex-col items-end text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                      <AccessTimeIcon fontSize="small" />
                      {new Date(motivo.Fecha).toLocaleDateString()}
                    </div>
                    <span className="text-[10px] text-gray-400">
                      {new Date(motivo.Fecha).toLocaleTimeString()}
                    </span>
                  </div>
                </div>

                {/* BODY */}
                <div className="space-y-2 text-sm text-gray-700">

                  <div className="flex items-center gap-2">
                    <BadgeIcon fontSize="small" className="text-gray-400" />
                    <span><strong>Cédula:</strong> {motivo.Cedula}</span>
                  </div>

                  <div className="flex items-center gap-2">
                    <PersonIcon fontSize="small" className="text-gray-400" />
                    <span>
                      {motivo.PrimerNombre} {motivo.SegundoNombre}{" "}
                      {motivo.ApellidoPaterno} {motivo.ApellidoMaterno}
                    </span>
                  </div>

                  <div className="flex items-center gap-2">
                    <AccountCircleIcon fontSize="small" className="text-gray-400" />
                    <span><strong>Usuario:</strong> {motivo.Usuario}</span>
                  </div>

                </div>

                {/* FOOTER opcional */}
                <div className="mt-4 border-t pt-2 text-xs text-gray-400 flex justify-between">
                  <span></span>
                  <span className="text-red-500 font-medium">PENDIENTE</span>
                </div>

              </div>
            ))}
          </div>

          {/* BOTÓN */}
          <div className="mt-6 flex justify-end">
            <button
              type="button"
              className="flex items-center gap-2 bg-primaryBlue text-white px-5 py-2 rounded-full text-sm hover:bg-white hover:text-primaryBlue border border-primaryBlue transition"
              onClick={() => navigate("/ListadoSolicitud", { replace: true })}
            >
              <AssignmentIcon fontSize="small" />
              {returnButtonText}
            </button>
          </div>
        </div>
      )}

      {Number(dataMotivos?.totalCount || 0) === 0 && Number(dataMotivosBodega?.totalCount || 0) === 0 && (
        <form
          className="w-full space-y-6"
          onSubmit={(e) => {
            e.preventDefault();
            // Validar y mostrar el primer error si hay alguno
            formik.validateForm().then((errors) => {
              if (Object.keys(errors).length > 0) {
                formik.setTouched(
                  Object.keys(errors).reduce((acc, key) => ({ ...acc, [key]: true }), {}),
                  false
                );
                showFirstError();
              } else {
                formik.handleSubmit(e);
              }
            });
          }}
        >
          {/* Fila 1: Bodega y Tipo de Consulta (2 columnas) */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {getFieldConfig("Bodega") && (
              <FormField {...getFieldConfig("Bodega")} formik={formik} />
            )}
            {getFieldConfig("idCompraEncuesta") && (
              <FormField {...getFieldConfig("idCompraEncuesta")} formik={formik} />
            )}
          </div>

          {/* Fila 2: Producto y Cédula con botón Validar */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {/* Producto */}
            {getFieldConfig("idProductos") && (
              <FormField
                {...getFieldConfig("idProductos")}
                formik={formik}
                datosPersonalesVisible={datosPersonalesVisible}
                setDatosPersonalesVisible={setDatosPersonalesVisible}
                setClienteRecurrenteA={setClienteRecurrenteA}
              />
            )}

            {/* Cédula con botón Validar */}
            <div className="flex flex-col">
              <label htmlFor="Cedula" className="flex items-center text-sm font-semibold text-slate-700 mb-2">
                <BadgeIcon className="mr-2 text-primaryBlue" fontSize="small" />
                Cédula
              </label>
              <div className="flex gap-2">
                <input
                  type="text"
                  name="Cedula"
                  id="Cedula"
                  value={formik.values.Cedula ?? ""}
                  onChange={handleCedulaInputChange}
                  onBlur={() => formik.handleBlur({ target: { name: "Cedula" } })}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleEjecutarValidacionCedula();
                    }
                  }}
                  maxLength={10}
                  placeholder="Ingresa 10 dígitos"
                  disabled={loadingCedula}
                  className={`flex-1 px-4 py-2.5 rounded-lg border ${
                    formik.errors.Cedula && formik.touched.Cedula
                      ? 'border-red-400 bg-red-50 focus:border-red-500 focus:ring-red-200'
                      : 'border-slate-300 bg-white focus:border-primaryBlue focus:ring-blue-200'
                  } focus:outline-none focus:ring-2 transition-all duration-200 text-sm ${
                    loadingCedula ? 'opacity-50 cursor-wait' : ''
                  }`}
                />
                <button
                  type="button"
                  onClick={handleEjecutarValidacionCedula}
                  disabled={loadingCedula || !esFormularioListoParaValidar}
                  className={`px-4 py-2.5 bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold rounded-lg shadow-md hover:shadow-lg hover:from-green-700 hover:to-green-800 transition-all duration-200 flex items-center gap-2 ${
                    (loadingCedula || !esFormularioListoParaValidar)
                      ? 'opacity-50 cursor-not-allowed'
                      : ''
                  }`}
                >
                  {loadingCedula ? (
                    <>
                      <CircularProgress size={20} sx={{ color: 'white' }} />
                      <span className="hidden sm:inline text-sm">Validando...</span>
                    </>
                  ) : (
                    <>
                      <CheckCircleOutlineIcon sx={{ fontSize: 20 }} />
                      <span className="hidden sm:inline text-sm">Validar</span>
                    </>
                  )}
                </button>
              </div>
              {loadingCedula && (
                <p className="mt-1 text-xs text-primaryBlue font-medium flex items-center">
                  <CircularProgress size={16} sx={{ color: '#2d3689', marginRight: '8px' }} />
                  Consultando datos...
                </p>
              )}
              {formik.errors.Cedula && formik.touched.Cedula && (
                <p className="mt-1 text-xs text-red-600 font-medium">{formik.errors.Cedula}</p>
              )}
            </div>
          </div>



          {/* Fila 3: Apellido Paterno, Apellido Materno, Primer Nombre, Segundo Nombre */}
          {datosPersonalesVisible && (
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
              {getFieldConfig("ApellidoPaterno") && (
                <FormField {...getFieldConfig("ApellidoPaterno")} formik={formik} />
              )}
              {getFieldConfig("ApellidoMaterno") && (
                <FormField {...getFieldConfig("ApellidoMaterno")} formik={formik} />
              )}
              {getFieldConfig("PrimerNombre") && (
                <FormField {...getFieldConfig("PrimerNombre")} formik={formik} />
              )}
              {getFieldConfig("SegundoNombre") && (
                <FormField {...getFieldConfig("SegundoNombre")} formik={formik} />
              )}
            </div>
          )}

          {/* Fila 4: Fecha Nacimiento, Edad, Situación Laboral, Celular */}
          {datosPersonalesVisible && (
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
              {getFieldConfig("FechaNacimeinto") && (
                <FormField {...getFieldConfig("FechaNacimeinto")} formik={formik} />
              )}
              {getFieldConfig("Edad") && (
                <FormField {...getFieldConfig("Edad")} formik={formik} />
              )}
              {getFieldConfig("idSituacionLaboral") && (
                <FormField {...getFieldConfig("idSituacionLaboral")} formik={formik} />
              )}
              {getFieldConfig("Celular") && (
                <FormField {...getFieldConfig("Celular")} formik={formik} />
              )}
            </div>
          )}

          {/* Fila 5: Email, Actividad Económica, Estabilidad Laboral, Tiempo de Vivienda */}
          {datosPersonalesVisible && (
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
              {getFieldConfig("Email") && (
                <FormField {...getFieldConfig("Email")} formik={formik} />
              )}
              {getFieldConfig("idActEconomina") && (
                <FormField {...getFieldConfig("idActEconomina")} formik={formik} />
              )}
              {getFieldConfig("idCre_Tiempo") && (
                <FormField {...getFieldConfig("idCre_Tiempo")} formik={formik} />
              )}
              {getFieldConfig("idCre_TiempoVivienda") && (
                <FormField {...getFieldConfig("idCre_TiempoVivienda")} formik={formik} />
              )}
            </div>
          )}

          {/* Términos y condiciones (solo si datosPersonalesVisible) */}
          {datosPersonalesVisible && includeTermsAndConditions && (
            <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mt-6 mb-4 pt-4 border-t border-slate-200">
              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="bTerminosYCondiciones"
                  id="bTerminosYCondiciones"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  checked={formik.values.bTerminosYCondiciones}
                  className="w-4 h-4 text-primaryBlue border-slate-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
                />
                <label htmlFor="bTerminosYCondiciones" className="text-slate-600 text-sm cursor-pointer">
                  Acepto los{" "}
                  <a
                    href="https://point.com.ec/terminos-y-condiciones"
                    className="text-primaryBlue hover:text-blue-800 font-semibold underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    términos y condiciones
                  </a>
                </label>
              </div>

              <div className="flex items-center gap-2">
                <input
                  type="checkbox"
                  name="bPoliticas"
                  id="bPoliticas"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  checked={formik.values.bPoliticas}
                  className="w-4 h-4 text-primaryBlue border-slate-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer"
                />
                <label htmlFor="bPoliticas" className="text-slate-600 text-sm cursor-pointer">
                  Acepto las{" "}
                  <a
                    href="https://point.com.ec/politicas-de-privacidad"
                    className="text-primaryBlue hover:text-blue-800 font-semibold underline"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    políticas de privacidad
                  </a>
                </label>
              </div>
            </div>
          )}
          {datosPersonalesVisible && (formik.errors.bTerminosYCondiciones || formik.errors.bPoliticas) && (
            <div className="text-center text-red-500 text-xs mb-3">
              {formik.errors.bTerminosYCondiciones && formik.touched.bTerminosYCondiciones && (
                <p>{formik.errors.bTerminosYCondiciones}</p>
              )}
              {formik.errors.bPoliticas && formik.touched.bPoliticas && (
                <p>{formik.errors.bPoliticas}</p>
              )}
            </div>
          )}

          {/* Botones de acción (solo si datosPersonalesVisible) */}
          {datosPersonalesVisible && includeButtons && (
            <div className="flex justify-center gap-4 pt-6 border-t border-slate-200">
              <button
                type="submit"
                disabled={isButtonDisabled || isSubmitting}
                className={`px-8 py-3 bg-gradient-to-r from-[#2d3689] to-[#212863] text-white font-semibold rounded-full shadow-lg hover:shadow-xl hover:from-[#212863] hover:to-[#171d47] transform hover:scale-105 transition-all duration-200 flex items-center space-x-2 ${(isButtonDisabled || isSubmitting) ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
              >
                {isSubmitting ? (
                  <Loader />
                ) : (
                  <>
                    <span>{submitButtonText}</span>
                    <SendIcon sx={{ fontSize: 20 }} />
                  </>
                )}
              </button>

              <button
                type="button"
                onClick={handleCancel}
                disabled={isCanceling}
                className={`px-8 py-3 bg-gradient-to-r from-slate-500 to-slate-600 text-white font-semibold rounded-full shadow-lg hover:shadow-xl hover:from-slate-600 hover:to-slate-700 transform hover:scale-105 transition-all duration-200 flex items-center space-x-2 ${isCanceling ? 'opacity-50 cursor-not-allowed' : ''
                  }`}
              >
                <span>{isCanceling ? "Cancelando..." : cancelButtonText}</span>
                <CancelIcon sx={{ fontSize: 20 }} />
              </button>

              <button
                type="button"
                onClick={() => navigate("/ListadoSolicitud", { replace: true })}
                className="px-8 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold rounded-full shadow-lg hover:shadow-xl hover:from-green-700 hover:to-green-800 transform hover:scale-105 transition-all duration-200 flex items-center space-x-2"
              >
                <span>{returnButtonText}</span>
                <ArrowBackIcon sx={{ fontSize: 20 }} />
              </button>
            </div>
          )}
          {
            <OTPModal
              isOpen={isOtpModalOpen}
              onClose={handleOtpModalClose}
              verifyFn={verificarOtpCode}
              phoneNumberOTP={formik.values.Celular}
              expiraEnMinutos={otpExpiraEnMinutos}
            />
          }
        </form>
      )}


      <MotivoContinuidad isOpen={isOpenMotivo} onClose={() => setIsOpenMotivo(false)} data={dataInforme} userData={userData} />

      <SolicitudExitosa
        isOpen={mensajeExitoso}
        onClose={() => setMensajeExitoso(false)}
        soliGrande={soliGrande}
        creSoliWeb={creSoliWeb}
        titulo={
          creSoliWeb?.Estado == 1
            ? '¡TU SOLICITUD DE CRÉDITO HA SIDO CREADA CON ÉXITO!'
            : (esProductoPayjoy ? 'RECUERDA QUE LA COMPRA DE TU CELULAR LO APRUEBA PAYJOY' : 'SOLICITUD NO APROBADA')
        }
        subtitulo={
          creSoliWeb?.Estado == 1
            ? 'Ahora puedes revisar el estado de tu solicitud de crédito.'
            : ''
        }
        color={creSoliWeb?.Estado == 1 ? 'bg-green-100' : 'bg-gray-100'}
        li1={
          creSoliWeb?.Estado == 1
            ? `Cliente ${`${creSoliWeb?.PrimerNombre} ${creSoliWeb?.ApellidoPaterno}`} con cedula ${creSoliWeb?.Cedula}`
            : ''
        }
        li2={
          creSoliWeb?.Estado == 1
            ? `Numero de solicitud: ${soliGrande?.data.NumeroSolicitud}`
            : (esProductoPayjoy
              ? (<button
                onClick={() => window.open("https://app.payjoy.com/merchant3/merchant-login", "_blank")}
                className="flex items-center justify-center gap-2 bg-green-600 text-white px-6 py-2.5 rounded-lg hover:bg-green-700 transition shadow-md mx-auto w-full max-w-xs"
              >
                <span>Consultar</span>
                <img
                  src={payjoy}
                  alt="IconoPayJoy"
                  className="w-9 h-9 object-contain"
                />
              </button>
              )
              : (<div className="text-center w-full">
                <p className="text-xl font-extrabold text-blue-700 leading-snug">
                  OFRECE AL CLIENTE OTRAS FORMAS DE PAGO
                </p>
                <p className="text-sm text-gray-600 mt-2">
                  Tarjeta de crédito u otras alternativas disponibles en tienda.
                </p>
              </div>
              ))
        }
        li3={creSoliWeb?.Estado == 1 ? `Cuota:${soliGrande?.data.CuotaAsignada} y Cupo: ${soliGrande?.data.Cupo}` : ''}
        ruta={'/ListadoSolicitud'}
      />

    </div>

  );

};

export default ReusableForm;



/*
ver que me devuelve cresoliweb y hacerle dinamico :p
*/